"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _Toggle = _interopRequireDefault(require("../helpers/Toggle"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _constants = require("../constants");
var _Link = _interopRequireDefault(require("../Link/Link"));
var _envConstants = require("../../env-constants");
var _ComponentWrapper = _interopRequireDefault(require("../helpers/ComponentWrapper"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StickyBanner = /*#__PURE__*/function (_Component) {
  function StickyBanner() {
    var _this;
    (0, _classCallCheck2["default"])(this, StickyBanner);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, StickyBanner, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      showBanner: true
    });
    (0, _defineProperty2["default"])(_this, "hideBanner", function () {
      if (_jsCookie["default"].get('hide_sticky_banner') === undefined) {
        _jsCookie["default"].set('hide_sticky_banner', true, {
          expires: 1
        });
      }
      _this.setState({
        showBanner: false
      });
    });
    return _this;
  }
  (0, _inherits2["default"])(StickyBanner, _Component);
  return (0, _createClass2["default"])(StickyBanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_jsCookie["default"].get('hide_sticky_banner') === 'true') {
        this.hideBanner();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var showBanner = this.state.showBanner;
      var _this$props = this.props,
        text = _this$props.text,
        link = _this$props.link,
        className = _this$props.className,
        cta = _this$props.cta;
      var env = _envConstants.ENV.SITE;
      if (showBanner) {
        return /*#__PURE__*/_react["default"].createElement(_Toggle["default"], {
          on: true
        }, function (_ref) {
          var toggle = _ref.toggle,
            on = _ref.on;
          return on && /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              zIndex: 9999
            },
            className: "d8-c-sticky-banner text-center d8-u-primary-bg ".concat(className)
          }, /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
            className: "d8-u-color-white margin-auto flex flex-center flex-column flex-row@md"
          }, /*#__PURE__*/_react["default"].createElement("p", {
            className: "relative margin-bottom-xs margin-bottom-0@md",
            style: {
              top: -2
            }
          }, link ? /*#__PURE__*/_react["default"].createElement(_Link["default"], {
            className: "d8-u-color-white d8-u-text-extra-bold",
            href: link
          }, text) : text), cta && cta.url && cta.text && /*#__PURE__*/_react["default"].createElement("div", {
            className: "margin-bottom-xs margin-bottom-0@md margin-left-md@md"
          }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
            link: cta.url && cta.url,
            buttonType: _constants.BUTTON_TYPES.PRIMARY,
            buttonSize: _constants.BUTTON_SIZES.SMALL,
            text: cta.text && cta.text
          })), /*#__PURE__*/_react["default"].createElement("div", {
            className: "bottom-0 right-0 padding-sm position-absolute position-relative@md"
          }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
            icon: "cross",
            buttonType: _constants.BUTTON_TYPES.BARE_WHITE_NO_PADDING,
            onClick: function onClick() {
              _this2.hideBanner();
              toggle();
            }
          })))));
        });
      }
      return null;
    }
  }]);
}(_react.Component);
StickyBanner.propTypes = {
  text: _propTypes["default"].string.isRequired,
  link: _propTypes["default"].string,
  className: _propTypes["default"].string,
  cta: _propTypes["default"].object
};
var _default = exports["default"] = StickyBanner;